// extracted by mini-css-extract-plugin
export default {"page":"Clinic_page__tVunW","tableCard":"Clinic_tableCard__E7NlZ","tableHeader":"Clinic_tableHeader__dteDb","tableTitle":"Clinic_tableTitle__sjMQB","addBtn":"Clinic_addBtn__3O0PX"};